/**
 * ユニークなIDを生成する
 * @param prefix - IDのプレフィックス
 * @returns 生成されたID
 */
export function generateId(prefix: string = 'id'): string {
  const timestamp = Date.now().toString(36)
  const randomStr = Math.random().toString(36).substring(2, 11)
  return `${prefix}_${timestamp}_${randomStr}`
}